import React, { useState } from 'react';
import {
	CaseDoctorSurvey,
	useLazyCaseCloseQuestionnaireQuery,
} from '../../graphql/graphql';
import { useEffectAsync } from '../../helpers';
import CaseCloseComponentModal from '../../Modules/Case/Components/CaseCloseComponentModal';
import CaseCloseQuestionnaireModal from '../../Modules/Case/Components/CaseCloseQuestionnaire/CaseCloseQuestionnaireModal';
import { CloseCaseButtonProps } from './CloseCaseButton';

interface Props extends CloseCaseButtonProps {
	onClose: () => void;
	resolveCall: () => void;
	onCaseClose: () => void;
}

const CloseCaseButtonStatic: React.FC<Props> = ({
	caseId,
	patientId,
	onCaseClose,
	caseData,
	resolveCall,
}) => {
	const [opened, setOpened] = useState(true);
	const [isAskForQuestionnaireOpen, setIsAskForQuestionnaireOpen] =
		useState(false);
	const [doctorSurvey, setDoctorSurvey] = useState<
		CaseDoctorSurvey | undefined
	>(undefined);
	const [getCaseData] = useLazyCaseCloseQuestionnaireQuery();

	const handleGetOrLoadCase = async () => {
		if (caseData) {
			return caseData;
		}
		const data = await getCaseData({ id: caseId });
		return data?.data?.case;
	};

	const handleRejectQuestionnaire = () => {
		setIsAskForQuestionnaireOpen(false);
		handleAfterCaseClose(true);
	};

	const handleAfterCaseClose = (forceClose = false) => {
		setOpened(false);
		resolveCall();

		if (doctorSurvey?.show && !forceClose) {
			setIsAskForQuestionnaireOpen(true);
			return;
		}

		onCaseClose();
	};

	useEffectAsync(async () => {
		const data = await handleGetOrLoadCase();
		if (data) {
			setDoctorSurvey(data?.doctorSurvey || undefined);
		}
	}, []);

	return (
		<>
			<CaseCloseComponentModal
				caseId={caseId}
				patientId={patientId}
				opened={opened}
				onClose={() => setOpened(false)}
				onCaseClose={handleAfterCaseClose}
			/>
			{isAskForQuestionnaireOpen && doctorSurvey && (
				<CaseCloseQuestionnaireModal
					onSkip={handleRejectQuestionnaire}
					onClose={handleRejectQuestionnaire}
					doctorSurvey={doctorSurvey}
					isOpen
				/>
			)}
		</>
	);
};

export default CloseCaseButtonStatic;
